var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_11908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5801 30.62L30.9701 25.79L22.5801 20.96V30.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.79 0C20.6892 0 15.703 1.51256 11.4619 4.3464C7.22071 7.18024 3.91514 11.2081 1.96316 15.9206C0.0111743 20.6331 -0.499554 25.8186 0.495559 30.8214C1.49067 35.8241 3.94693 40.4195 7.55373 44.0263C11.1605 47.6331 15.7559 50.0893 20.7586 51.0845C25.7614 52.0796 30.9469 51.5688 35.6594 49.6169C40.3719 47.6649 44.3998 44.3593 47.2336 40.1182C50.0675 35.877 51.58 30.8908 51.58 25.79C51.58 18.9501 48.8629 12.3903 44.0263 7.55372C39.1897 2.71715 32.6299 0 25.79 0M41.91 25.82C41.9262 28.4185 41.7019 31.0129 41.24 33.57C41.0591 34.2517 40.7011 34.8735 40.2023 35.3723C39.7035 35.871 39.0818 36.2291 38.4 36.41C35.88 37.07 25.79 37.07 25.79 37.07C25.79 37.07 15.73 37.07 13.18 36.38C12.4983 36.1991 11.8765 35.841 11.3777 35.3423C10.879 34.8435 10.521 34.2217 10.34 33.54C9.88397 30.9822 9.66305 28.3881 9.68001 25.79C9.66162 23.1786 9.88254 20.5711 10.34 18C10.5282 17.3185 10.8881 16.6968 11.3854 16.1943C11.8826 15.6918 12.5006 15.3253 13.18 15.13C15.7 14.47 25.79 14.47 25.79 14.47C25.79 14.47 35.88 14.47 38.4 15.16C39.0818 15.3409 39.7035 15.699 40.2023 16.1977C40.7011 16.6965 41.0591 17.3183 41.24 18C41.7128 20.5658 41.9372 23.1712 41.91 25.78",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_11908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.58,
    height: 51.58,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube01);
export default __webpack_public_path__ + "static/media/youtube01.8ad5aa5ee0ea839cd226a3886fd23d88.svg";
export { ForwardRef as ReactComponent };